export default {
  product_selection: {
    checkbox: "Vytvořit odkaz do mikrosite produktu či kolekce?"
  }
}
